import { Button } from "@/components/ui/button";
import { useNavigate, useLocation } from "react-router-dom";
import { Home } from "lucide-react";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const goToSection = (sectionId: string) => {
    if (location.pathname !== "/") {
      // Navigate to home first
      navigate("/");

      // Scroll after navigation
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 150); // slight delay to let homepage render
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  const goHome = () => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 150);
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur border-b border-border">
      <nav className="container mx-auto px-6 py-4 flex items-center justify-between">
        {/* ✅ Logo now navigates back to home and scrolls to top */}
        <button
          onClick={goHome}
          className="flex items-center gap-2 text-xl font-semibold text-foreground hover:opacity-80 transition-opacity"
        >
          <Home className="h-5 w-5" />
          SmartEQT™
        </button>

        <div className="hidden md:flex items-center space-x-8">
          <button
            onClick={() => goToSection("problem")}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            Problem
          </button>
          <button
            onClick={() => goToSection("vision")}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            Vision
          </button>
          <button
            onClick={() => goToSection("why")}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            Why Now
          </button>
          <Button variant="outline" size="sm" onClick={() => goToSection("cta")}>
            Join / Request
          </Button>
        </div>
      </nav>
    </header>
  );
};

export default Header;
